import React from 'react'
import styled from 'styled-components'
import Card2 from './Card2'
import { InnerLayout } from './Layout'
import check from '../../Assets/img/check.svg';
import checkDisabled from '../../Assets/img/check-disabled.svg';

const DetailCard = () => {
   return (
      <PaymentStyled id='pricing'>
         <InnerLayout>
            <div data-aos='fade-down-right'>
            <h3 className="small-heading">
               Exceptional training, <span>at  the right price</span>
               </h3>
               <p className="c-para"> With an instructor by your side, you will feel confident and supported </p>
            </div>
            <div className='card-con'>
               <Card2
                  account={'Learning Objectives'}
                  text={'Perfect for individuals seeking new skills or enhancing their portfolio'}
                  check={check}
                  checkDis={checkDisabled}
                  text1={'Participants create working methodologies and conceptual framework of developing appropriate systems of tech development.'}
                  text2={'Participants are also provided an opportunity to design and implement ethical tools for software engineering and design workflows when developing their Apps.'}
                  text3={'Participants are guided to take charge of their own tech development by learning systematically about the technology changes that occur in their society.'}
                  text4={'Participants consciously incorporate in their continuous learning process appropriate elements from experiences of other people and groups in the communities who are facing similar challenges.'}
                  text5={'Participants are provided an opportunity to envision people as resources for social change and that an appropriate tech development process can help develop communities.'}
                  text6={'Participants learn about the chains of activities related to the tech development process and search for alternative systems of tech development processes for their specific regions.'}
               />
            </div>
         </InnerLayout>
      </PaymentStyled>
   )
}

const PaymentStyled = styled.section`
 .card-con {
    display: flex; /* Use flexbox for centering */
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    padding-top: 4rem; /* Adjust top padding */
    
    /* Optional: Use max-width to control the card's maximum size */
    max-width: 1200px; 
    margin: 0 auto;
    width: 100%; /* Ensure it takes full width of the container */
    
    /* Optional: If you want to increase the width of the cards themselves */
    .card2 {
      width: 100%; /* Adjust the width of individual cards */
      max-width: 100%; /* You can set a specific width like 80% or more */
    }

    @media screen and (max-width: 689px) {
      flex-direction: column; /* Stack content on mobile */
    }
  }

  p {
    text-align: center;
  }
`

export default DetailCard
